import { axiosPlugin } from '@/api';
import Aura from '@primevue/themes/aura';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import { createApp } from 'vue';
import * as Sentry from "@sentry/vue";
import { VueReCaptcha } from 'vue-recaptcha-v3'
import posthogPlugin from "../plugins/posthog"; //import the plugin. 

import App from './App.vue';
import './assets/styles.scss';
import './assets/tailwind.css';
// import './registerServiceWorker.js';
import router from './router';

const app = createApp(App);
const pinia = createPinia();
app.use(router);
app.use(pinia);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '.app-dark',
    },
  },
});

if ('serviceWorker' in navigator) {
  // Only in development or specific testing mode
  caches.keys().then((cacheNames) => {
    cacheNames.forEach((cacheName) => {
      caches.delete(cacheName);
    });
  });
}

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DNS_URL,
});

// recaptch v3
app.use(VueReCaptcha, {
  siteKey: import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY,
  loaderOptions: {
    autoHideBadge: true,
    explicitRenderParameters: {
        badge: 'bottomright',
    },
  }
})

app.use(ToastService);
app.use(axiosPlugin);
app.use(ConfirmationService);
app.use(posthogPlugin); //install the plugin

app.mount('#app');
